// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../../provider/Context.bs.js");
var Atom_Cell = require("./Atom_Cell.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Type_Image = require("../../type/Type_Image.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_String = require("../../type/Type_String.bs.js");
var Atom_Image_Ds = require("./Atom_Image_Ds.bs.js");
var Atom_Image_Css = require("./Atom_Image_Css.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Atom_Image_Selector = require("./Atom_Image_Selector.bs.js");
var UseScreenResolution = require("../../hook/UseScreenResolution.bs.js");
var Particle_ImageCdn_Ds = require("../particle/Particle_ImageCdn_Ds.bs.js");
var Particle_Accessibility_Constant = require("../particle/Particle_Accessibility_Constant.bs.js");

function Atom_Image$Generic(Props) {
  var accessibility = Props.accessibility;
  var alignSelf = Props.alignSelf;
  var alt = Props.alt;
  var animation = Props.animation;
  var autoSize = Props.autoSize;
  var border = Props.border;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var identifier = Props.identifier;
  var kindOpt = Props.kind;
  var rules = Props.rules;
  var src = Props.src;
  var style = Props.style;
  var kind = kindOpt !== undefined ? kindOpt : /* Normal */0;
  var style$1 = Atom_Image_Ds.make(style);
  var match = Atom_Image_Ds.view(style$1);
  var imagePlaceholderFeatureFlipping = Context.Config.getFeatureFlippingStatus(/* ImagePlaceholder */0);
  var match$1 = Atom_Image_Css.toCss(imagePlaceholderFeatureFlipping, style$1);
  var screenSize = UseScreenResolution.make(undefined, undefined);
  var srcs = Particle_Screen_Ds.zipWith((function (width, ratio) {
          return Atom_Image_Selector.getUrl(width, Belt_Array.keep(src, (function (param) {
                            return Type_Image.Ratio.areRatioEquals(Type_Image.Ratio.makeFromDimensions(param.w, param.h), ratio);
                          })));
        }), Belt_Option.getWithDefault(match.width, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 0)), match.ratio);
  var defaultSrc = Particle_Screen_Ds.extractDefaultValue(srcs);
  var match$2 = React.useState(function () {
        return defaultSrc;
      });
  var setSrcByScreenSize = match$2[1];
  var srcByScreenSize = match$2[0];
  React.useEffect((function () {
          var isMount = {
            contents: true
          };
          if (isMount.contents === true) {
            Curry._1(setSrcByScreenSize, (function (param) {
                    return Belt_Option.getWithDefault(Particle_Screen_Ds.getValueByScreenSize(screenSize, srcs), defaultSrc);
                  }));
          }
          return (function (param) {
                    isMount.contents = false;
                  });
        }), [screenSize]);
  var rules$1 = Particle_Screen_Ds.$$Array.concatOrDefault(match$1.image, rules);
  if (kind) {
    var tmp = {
      kind: {
        TAG: /* Image */7,
        _0: srcByScreenSize,
        _1: alt
      },
      children: null,
      rules: rules$1
    };
    if (alignSelf !== undefined) {
      tmp.alignSelf = Caml_option.valFromOption(alignSelf);
    }
    if (border !== undefined) {
      tmp.border = Caml_option.valFromOption(border);
    }
    var tmp$1 = {
      children: React.createElement(Atom_Cell.make, tmp)
    };
    if (autoSize !== undefined) {
      tmp$1.autoSize = Caml_option.valFromOption(autoSize);
    }
    if (display !== undefined) {
      tmp$1.display = Caml_option.valFromOption(display);
    }
    if (displayOrder !== undefined) {
      tmp$1.displayOrder = Caml_option.valFromOption(displayOrder);
    }
    if (identifier !== undefined) {
      tmp$1.identifier = Caml_option.valFromOption(identifier);
    }
    if (match$1.gradient !== undefined) {
      tmp$1.rules = Caml_option.valFromOption(match$1.gradient);
    }
    if (animation !== undefined) {
      tmp$1.animation = Caml_option.valFromOption(animation);
    }
    return React.createElement(Atom_Cell.make, tmp$1);
  }
  var tmp$2 = {
    kind: {
      TAG: /* Image */7,
      _0: srcByScreenSize,
      _1: alt
    },
    children: null,
    rules: rules$1
  };
  if (accessibility !== undefined) {
    tmp$2.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (alignSelf !== undefined) {
    tmp$2.alignSelf = Caml_option.valFromOption(alignSelf);
  }
  if (autoSize !== undefined) {
    tmp$2.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (display !== undefined) {
    tmp$2.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp$2.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (border !== undefined) {
    tmp$2.border = Caml_option.valFromOption(border);
  }
  if (identifier !== undefined) {
    tmp$2.identifier = Caml_option.valFromOption(identifier);
  }
  if (animation !== undefined) {
    tmp$2.animation = Caml_option.valFromOption(animation);
  }
  return React.createElement(Atom_Cell.make, tmp$2);
}

function Atom_Image(Props) {
  var accessibility = Props.accessibility;
  var alignSelf = Props.alignSelf;
  var alt = Props.alt;
  var animation = Props.animation;
  var autoSize = Props.autoSize;
  var border = Props.border;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var identifier = Props.identifier;
  var kindOpt = Props.kind;
  var rules = Props.rules;
  var src = Props.src;
  var style = Props.style;
  var kind = kindOpt !== undefined ? kindOpt : /* Normal */0;
  var tmp = {
    alt: alt,
    kind: kind,
    src: src,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (alignSelf !== undefined) {
    tmp.alignSelf = Caml_option.valFromOption(alignSelf);
  }
  if (animation !== undefined) {
    tmp.animation = Caml_option.valFromOption(animation);
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (border !== undefined) {
    tmp.border = Caml_option.valFromOption(border);
  }
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  return React.createElement(Atom_Image$Generic, tmp);
}

function Atom_Image$ImageTmp(Props) {
  var accessibilityOpt = Props.accessibility;
  var alignSelf = Props.alignSelf;
  var alt = Props.alt;
  var animation = Props.animation;
  var autoSize = Props.autoSize;
  var border = Props.border;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var identifier = Props.identifier;
  var kindOpt = Props.kind;
  var rules = Props.rules;
  var src = Props.src;
  var style = Props.style;
  var accessibility = accessibilityOpt !== undefined ? accessibilityOpt : Particle_Accessibility_Constant.ariaHidden;
  var kind = kindOpt !== undefined ? kindOpt : /* Normal */0;
  var style$1 = Atom_Image_Ds.make(style);
  var match = Atom_Image_Css.toCss(undefined, style$1);
  var image = match.image;
  if (kind) {
    var rules$1 = Particle_Screen_Ds.$$Array.concatOrDefault(image, rules);
    var tmp = {
      kind: {
        TAG: /* Image */7,
        _0: src,
        _1: alt
      },
      children: null,
      rules: rules$1
    };
    if (alignSelf !== undefined) {
      tmp.alignSelf = Caml_option.valFromOption(alignSelf);
    }
    if (border !== undefined) {
      tmp.border = Caml_option.valFromOption(border);
    }
    var tmp$1 = {
      children: React.createElement(Atom_Cell.make, tmp)
    };
    if (autoSize !== undefined) {
      tmp$1.autoSize = Caml_option.valFromOption(autoSize);
    }
    if (display !== undefined) {
      tmp$1.display = Caml_option.valFromOption(display);
    }
    if (displayOrder !== undefined) {
      tmp$1.displayOrder = Caml_option.valFromOption(displayOrder);
    }
    if (identifier !== undefined) {
      tmp$1.identifier = Caml_option.valFromOption(identifier);
    }
    if (match.gradient !== undefined) {
      tmp$1.rules = Caml_option.valFromOption(match.gradient);
    }
    if (animation !== undefined) {
      tmp$1.animation = Caml_option.valFromOption(animation);
    }
    return React.createElement(Atom_Cell.make, tmp$1);
  }
  var rules$2 = Particle_Screen_Ds.$$Array.concatOrDefault(image, rules);
  var tmp$2 = {
    accessibility: accessibility,
    kind: {
      TAG: /* Image */7,
      _0: src,
      _1: alt
    },
    children: null,
    rules: rules$2
  };
  if (alignSelf !== undefined) {
    tmp$2.alignSelf = Caml_option.valFromOption(alignSelf);
  }
  if (autoSize !== undefined) {
    tmp$2.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (display !== undefined) {
    tmp$2.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp$2.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (border !== undefined) {
    tmp$2.border = Caml_option.valFromOption(border);
  }
  if (identifier !== undefined) {
    tmp$2.identifier = Caml_option.valFromOption(identifier);
  }
  if (animation !== undefined) {
    tmp$2.animation = Caml_option.valFromOption(animation);
  }
  return React.createElement(Atom_Cell.make, tmp$2);
}

var ImageTmp = {
  make: Atom_Image$ImageTmp
};

function makeSrc(style, cdnUrl) {
  if (typeof style === "number" || style.TAG !== /* FromCdn */1) {
    return ;
  } else {
    return Particle_ImageCdn_Ds.make(style._0, cdnUrl);
  }
}

function Atom_Image$ImageFromCdn(Props) {
  var alt = Props.alt;
  var style = Props.style;
  var match = Context.Config.getState(undefined);
  var src = makeSrc(style, match.cdnUrl);
  if (src !== undefined) {
    return React.createElement(Atom_Image$ImageTmp, {
                alt: alt,
                src: Curry._1(Type_String.$$String.toString, src),
                style: style
              });
  } else {
    return null;
  }
}

var ImageFromCdn = {
  makeSrc: makeSrc,
  make: Atom_Image$ImageFromCdn
};

function Atom_Image$Papa(Props) {
  var alt = Props.alt;
  var identifier = Props.identifier;
  var src = Props.src;
  var tmp = {
    accessibility: Particle_Accessibility_Constant.ariaHidden,
    alt: alt,
    src: src,
    style: /* PapaLandscape */8
  };
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  return React.createElement(Atom_Image$Generic, tmp);
}

var Papa = {
  make: Atom_Image$Papa
};

function Atom_Image$Presse(Props) {
  var accessibility = Props.accessibility;
  var alt = Props.alt;
  var animation = Props.animation;
  var autoSize = Props.autoSize;
  var identifier = Props.identifier;
  var kind = Props.kind;
  var src = Props.src;
  var style = Props.style;
  var tmp = {
    alt: alt,
    animation: animation,
    autoSize: autoSize,
    kind: kind,
    src: src,
    style: style
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  return React.createElement(Atom_Image$Generic, tmp);
}

var Presse = {
  make: Atom_Image$Presse
};

var make = Atom_Image;

exports.make = make;
exports.ImageTmp = ImageTmp;
exports.ImageFromCdn = ImageFromCdn;
exports.Papa = Papa;
exports.Presse = Presse;
/* react Not a pure module */
